"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "SPEED",
    value: "10GBPS"
  }, {
    label: "UPTIME",
    value: "99.9%"
  }, {
    label: "SERVERS",
    value: "5000+"
  }];
  return <section data-section-id="3626" id="herovpngenixcommand" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/vpn_network_global.png)]" />
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 4%, 0.4) 0%, hsla(0, 0%, 4%, 0.85) 70%, hsla(0, 0%, 2%, 0.95) 100%)"
    }} />
      <div className="absolute inset-0 bg-background/60" />

      {}
      <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(22, 100%, 50%, 0.15) 0%, transparent 50%)"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border/60" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-primary" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
                N° 001 — Secure Access
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-foreground">
              <span className="block text-[clamp(3.5rem,12vw,10rem)]">ULTIMATE</span>
              <span className="block text-[clamp(3.5rem,12vw,10rem)] sm:pl-[8vw] lg:pl-[120px]">
                PRIVACY
              </span>
            </h1>

            <p className="font-default font-bold text-lg sm:text-xl text-foreground mt-6 max-w-[560px]">
              VPNGENIX delivers military-grade encrypted VPN protection across 5000+ global servers with 99.9% uptime, securing your online privacy with lightning-fast speeds.
            </p>

            {}
            <div className="my-10 h-[2px] w-20 bg-primary" />

            {}
            <p className="font-serif italic text-lg sm:text-xl text-muted-foreground max-w-[520px] leading-relaxed">
              Protect your digital footprint with the most advanced encryption protocols available today.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="group h-14 px-8 bg-primary text-primary-foreground font-default font-bold uppercase tracking-wider text-sm shadow-2xl hover:bg-primary hover:shadow-[0_0_32px_hsla(22,100%,50%,0.7)] transition-all duration-300">
                <Link to="/VpnReviewsPage">
                  Get Started Now
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="link" className="font-mono text-xs uppercase tracking-[0.25em] text-foreground hover:text-primary h-14 px-2">
                <Link to="/VpnReviewsPage">View Our Reviews →</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              <div className="absolute right-0 top-0 bottom-0 w-px bg-border/60" />
              <div className="font-mono text-xs uppercase text-muted-foreground tracking-[0.2em] whitespace-nowrap pr-6" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                N° 001 / VPNGENIX SECURE / GLOBAL NODES / ENCRYPTED 24.11
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative z-10 mt-16 flex flex-col gap-8">
          {}
          <div className="flex items-center gap-3">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
              Scroll
            </span>
            <ChevronDown className="size-4 text-primary animate-bounce" />
          </div>

          {}
          <div className="h-px w-full bg-border/60" />

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
            {dataPoints.map((point, i) => <div data-index={i} key={point.label} className="flex items-baseline gap-4">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
                  {point.label}
                </span>
                <span className="font-default font-bold text-lg text-primary">
                  {point.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/60" />
    </section>;
}